// import { ENEXPECTED_ERROR, UPDATE_SUCCESSFUL } from "@/Constant";
import { MotifToast } from "@ey-xd/motif-react";
import { useState } from "react";
type NotificationProps = {
  show?: boolean;
  message?: string;
  type?: string;
  supportingText?: string;
  scrollToTop?: boolean;
};

export default function NotificationGrid({
  show = true,
  message = "",
  type = "error",
  supportingText = "",
  scrollToTop = true
}: NotificationProps) {
  const [showMessage, setShowMessage] = useState({
    show: show,
    type: type,
    message: message,
    supportingText: supportingText,
  });
  const closeMessageHandler = () => {
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const notificationMessage =
    type === "error"
      ? message === ""
        ? "global.globalNotifications.unExpectedError"
        : message
      : message === ""
      ? "global.globalNotifications.updatedSuccessfully"
      : message;
  if (!showMessage.show) {
    return null;
  }

  return (
    <>
      {scrollToTop && window.scrollTo(0, 0)}
      <MotifToast
        onClose={closeMessageHandler}
        //@ts-ignore
        variant={showMessage.type}
        supportingText={showMessage.supportingText}
      >
        {" "}
        {notificationMessage}
      </MotifToast>
    </>
  );
}
